import {
  GETVOUCHERDETAILS_SUCCESS,
  GETVOUCHERDETAILS_FAILED,
  RESET_GETVOUCHERDETAILS,
  LOADING_GETVOUCHERDETAILS,
  NETWORK_ERROR_GETVOUCHERDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVOUCHERDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVOUCHERDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVOUCHERDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVOUCHERDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVOUCHERDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
